import { Box } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { BASE_HELP_OPTIONS } from 'features/OrderHelpRequest/model/consts';
import {
    HelpRequestOptionsList,
    HelpRequestSectionBody,
    HelpRequestSectionTitle,
} from 'features/OrderHelpRequest/ui/HelpRequestComponents';

export const InfoSection = memo(
    ({ isHelpOptions }: { isHelpOptions: boolean }) => {
        const { t } = useTranslation();
        return (
            <>
                <Box mb="40px">
                    <HelpRequestSectionTitle title={t('Reach out to seller')} />
                    <HelpRequestSectionBody>
                        {t(
                            'Contact the seller related to your issue. ' +
                                'Most issues are resolved by working with the seller' +
                                ' directly. This includes issues like:',
                        )}
                    </HelpRequestSectionBody>
                    {isHelpOptions && (
                        <HelpRequestOptionsList options={BASE_HELP_OPTIONS} />
                    )}
                </Box>
                <Box mb="40px">
                    <HelpRequestSectionTitle title={t('Still need help?')} />
                    <HelpRequestSectionBody sx={{ mb: '24px' }}>
                        {t(
                            "If the seller hasn't responded within 24 hours," +
                                ' come back here to contact the RE-OPS Help team.',
                        )}
                    </HelpRequestSectionBody>
                </Box>
            </>
        );
    },
);
InfoSection.displayName = 'InfoSection';
